import { useState } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { ShieldCheck } from 'lucide-react';
import { SummaryTab } from './tabs/SummaryTab';
import { UsersTab } from './tabs/UsersTab';
import { RolesTab } from './tabs/RolesTab';
import { AuditTab } from './tabs/AuditTab';
import { BillingTab } from './tabs/BillingTab';

const TABS = [
  { id: 'summary', label: 'Resumen' },
  { id: 'users', label: 'Usuarios' },
  { id: 'roles', label: 'Roles y permisos' },
  { id: 'billing', label: 'Facturación' },
  { id: 'audit', label: 'Auditoria' },
] as const;

export function AdminPage() {
  const [tab, setTab] = useState<(typeof TABS)[number]['id']>('summary');

  return (
    <div className="flex h-full flex-col">
      <header
        className="flex h-14 shrink-0 items-center gap-3 border-b px-6"
        style={{ background: 'var(--surface-1)', borderColor: 'var(--border-subtle)' }}
      >
        <ShieldCheck size={16} strokeWidth={1.8} style={{ color: 'var(--accent)' }} />
        <div>
          <div className="text-[10px] uppercase tracking-[0.18em]" style={{ color: 'var(--text-muted)' }}>
            Administracion
          </div>
          <div className="text-sm leading-none" style={{ fontFamily: 'var(--font-display)', fontWeight: 700 }}>
            Panel de control
          </div>
        </div>
      </header>

      <Tabs.Root value={tab} onValueChange={(v) => setTab(v as typeof tab)} className="flex flex-1 flex-col overflow-hidden">
        <Tabs.List className="flex shrink-0 items-center gap-1 border-b px-4 py-2" style={{ background: 'var(--surface-1)', borderColor: 'var(--border-subtle)' }}>
          {TABS.map((t) => (
            <Tabs.Trigger
              key={t.id}
              value={t.id}
              className="rounded-[var(--radius-sm)] px-3 py-1.5 text-sm transition-colors duration-150"
              style={{
                background: tab === t.id ? 'var(--accent)' : 'transparent',
                color: tab === t.id ? 'var(--surface-base)' : 'var(--text-secondary)',
              }}
            >
              {t.label}
            </Tabs.Trigger>
          ))}
        </Tabs.List>

        <div className="flex-1 overflow-y-auto p-6 scrollbar-thin">
          <Tabs.Content value="summary"><SummaryTab /></Tabs.Content>
          <Tabs.Content value="users"><UsersTab /></Tabs.Content>
          <Tabs.Content value="roles"><RolesTab /></Tabs.Content>
          <Tabs.Content value="billing"><BillingTab /></Tabs.Content>
          <Tabs.Content value="audit"><AuditTab /></Tabs.Content>
        </div>
      </Tabs.Root>
    </div>
  );
}
